<template>
	<div class="tutorial">
		<GameStage
			:stage="stage"
			:componentTypes="componentTypes"
			:fillTiles="false"
		/>
		<transition name="fade">
			<ArrowButton :action="skip"
				:direction="'right'" v-if="nextTooltipExists">{{ skipText }}</ArrowButton>
		</transition>
	</div>
</template>

<script>
import GameStage from '@/components/views/GameStage';
import ArrowButton from '@/components/abstract/ArrowButton';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
	name: 'Tutorial',
	components: {
		GameStage,
		ArrowButton,
	},
	props: ["stage"],
	data() {
		return {
			skipped: false,
			componentTypes: {
				cat: 'TutorialCat',
				foodBag: 'TutorialFoodBag',
				timebar: 'TutorialTimeBar',
			},
		};
	},
	computed: {
		...mapGetters([
			"nextTooltipExists",
			"occupiedTiles",
		]),
		...mapState({
			skipText: state => state.config.tutorial.skip_button_text,
		}),
		tiles() {
			return [
				this.$store.getters.vacantTiles[0],
				this.$store.getters.vacantTiles[this.$store.getters.vacantTiles.length - 1],
			];
		},
	},
	watch: {
		nextTooltipExists(nextTooltipExists) {
			if (!nextTooltipExists) {
				this.$store.commit("completeTutorial");

				if (!this.skipped) {
					this.sendEvent({
						ec: "Game",
						ea: "Tutorial",
						el: "Complete",
					});
				}
			}
		},
	},
	methods: {
		...mapActions([
			"startCycle",
			"skipTutorial",
			"sendEvent",
		]),
		populateTiles() {
			this.tiles.forEach((tile) => {
				tile.insertCat(this.$store.getters.randomBreedName(), "walking");
			});

			this.$nextTick(() => {
				this.occupiedTiles.forEach((tile, index) => {
					tile.$refs.cat.setCatIndex(index);
				});
			});
		},
		skip() {
			this.skipped = true;
			this.skipTutorial();
			this.sendEvent({
				ec: "Game",
				ea: "Tutorial",
				el: "Skip",
			});

			this.occupiedTiles.forEach((tile) => {
				while (tile.$refs.cat.clicksRemaining) {
					tile.$refs.cat.$refs.innerCat.feed();
				}
			});
		},
	},
	mounted() {
		this.$store.commit("activateTutorial");
		this.$nextTick(() => {
			this.startCycle();
			this.populateTiles();
		});
	},
	beforeDestroy() {
		this.$store.commit("deactivateTutorial");
	},
};
</script>

<style lang="scss" scoped>
.tutorial {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Tutorial.vue